import React, { useEffect, useState } from "react";
import { Table, Button } from "antd"; // Import Button from Ant Design

function SweetShopDetail({ allData }) {
  // console.log(allData)
  const [data, setData] = useState([]);
  // const [showAll, setShowAll] = useState(false); // State to manage visibility of all data

  useEffect(() => {
    setData(allData);
  }, [allData]);


  const columns = [
    {
      title: "Actual Price",
      dataIndex: ["item", "actualPrice"],
      key: "workingDays",
    },
    {
      title: "Selling Quantity",
      dataIndex: ["item", "sellingQuantity"],
      key: "sellingQuantity",
    },
    {
      title: "Selling Price",
      dataIndex: ["item", "sellingPrice"],
      key: "sellingPrice",
    },
    {
      title: "Total Actual Amount",
      dataIndex: ["item", "totalActualAmount"],
      key: "totalActualAmount",
    },
    {
      title: "Total Selling Amount",
      dataIndex: ["item", "totalSellingAmount"],
      key: "totalSellingAmount",
    },
    {
      title: "Gross Profit",
      dataIndex: ["item", "grossProfit"],
      key: "grossProfit",
    },
    {
      title: "Item Materials",
      key: "itemMaterials",
      render: (text, record) => (
        record.itemMaterials && record.itemMaterials.length > 0 ? (
          <ul>
            {record.itemMaterials.map((material, index) => (
              <li key={index}>
                <strong>Item:</strong> {material?.name}, &nbsp;
                <strong>price:</strong> {material?.price}, &nbsp;
                <strong>quantity:</strong> {material?.quantity}, &nbsp;
                <strong>totalAmount:</strong> {material?.totalAmount}
              </li>
            ))}
          </ul>
        ) : (
          "No item materials"
        )
      ),
    },
  ];

  return (
    <div className="container-fluid">
        <h5 className="card-title">{data[0]?.shop?.name}</h5>
        <p className="card-text">Working Days: {data[0]?.shop?.workingDays}</p>
      <div>
        <Table
          columns={columns}
          dataSource={data} // Show only 3 rows initially
          rowKey={(record, index) => index}
          pagination={false}
        />
        {/* {data.length > 3 && (
          <div className="text-center mt-3">
            <Button onClick={() => setShowAll(!showAll)} block>
              {showAll ? 'Show Less' : 'View All'}
            </Button>
          </div>
        )} */}
      </div>
    </div>
  );
}

export default SweetShopDetail;
